import { __ } from '@wordpress/i18n';

const propelInit = function() {
const addNumberInputButtons = (scope = document) => {
	const numberInputs = scope.querySelectorAll('input[type="number"]');

	if (0 === numberInputs.length) {
		return;
	}

	numberInputs.forEach(function (numberInput) {
		const wrapper = document.createElement('div');
		const decreaseButton = document.createElement('button');
		const increaseButton = document.createElement('button');

		decreaseButton.setAttribute('type', 'button');
		increaseButton.setAttribute('type', 'button');

		decreaseButton.setAttribute(
			'aria-label',
			__('Decrease value.', 'propel')
		);

		increaseButton.setAttribute(
			'aria-label',
			__('Increase value.', 'propel')
		);

		wrapper.classList.add('input-number');
		numberInput.classList.add('input-number__input');
		decreaseButton.classList.add('input-number__decrease');
		increaseButton.classList.add('input-number__increase');

		if (numberInput.classList.contains('hover')) {
			increaseButton.classList.add('hover');
		}

		decreaseButton.addEventListener('click', (e) => {
			e.preventDefault();
			e.currentTarget.nextElementSibling.nextElementSibling.stepDown();
		});

		increaseButton.addEventListener('click', (e) => {
			e.preventDefault();
			e.currentTarget.nextElementSibling.stepUp();
		});

		if (
			!numberInput.hasAttribute('step') ||
			'any' === numberInput.getAttribute('step')
		) {
			numberInput.setAttribute('step', 1);
		}

		numberInput.parentNode.insertBefore(wrapper, numberInput);
		wrapper.appendChild(decreaseButton);
		wrapper.appendChild(increaseButton);
		wrapper.appendChild(numberInput);
	});
};

const addFileInputButtons = (scope = document) => {
	const fileInputs = scope.querySelectorAll('input[type="file"]');

	if (0 === fileInputs.length) {
		return;
	}

	fileInputs.forEach(function (fileInput) {
		const wrapper = document.createElement('div');
		const fileButton = document.createElement('button');
		const fileCancelButton = document.createElement('button');

		fileButton.setAttribute('type', 'button');
		fileCancelButton.setAttribute('type', 'button');
		fileButton.innerText = __('Choose file.', 'propel');

		fileCancelButton.setAttribute(
			'aria-label',
			__('Remove file.', 'propel')
		);

		wrapper.classList.add('input-file');
		fileInput.classList.add('input-file__input');
		fileButton.classList.add('input-file__button');
		fileCancelButton.classList.add('input-file__cancel-button');

		fileButton.addEventListener('click', (e) => {
			e.preventDefault();
			e.currentTarget.nextElementSibling.click();
		});

		fileCancelButton.addEventListener('click', (e) => {
			e.preventDefault();
			e.currentTarget.previousElementSibling.value = '';

			e.currentTarget.previousElementSibling.classList.remove(
				'input-file__input--has-value'
			);
		});

		fileInput.parentNode.insertBefore(wrapper, fileInput);
		wrapper.appendChild(fileButton);
		wrapper.appendChild(fileInput);
		wrapper.appendChild(fileCancelButton);

		fileInput.addEventListener('change', (e) => {
			if (e.currentTarget.value && e.currentTarget.value !== '') {
				e.currentTarget.classList.add('input-file__input--has-value');
			} else {
				e.currentTarget.classList.remove(
					'input-file__input--has-value'
				);
			}
		});
	});
};

const addSearchInputButtons = (scope = document) => {
	const searchInputs = scope.querySelectorAll(
		'input[type="search"]:not(.custom-search-input)'
	);

	if (0 === searchInputs.length) {
		return;
	}

	searchInputs.forEach(function (searchInput) {
		const wrapper = document.createElement('div');
		const submitButton = document.createElement('button');
		const clearButton = document.createElement('button');

		submitButton.setAttribute('type', 'button');
		clearButton.setAttribute('type', 'button');
		submitButton.setAttribute('aria-label', __('Search.', 'propel'));
		clearButton.setAttribute('aria-label', __('Clear search.', 'propel'));
		wrapper.classList.add('input-search');
		searchInput.classList.add('input-search__input');
		submitButton.classList.add('input-search__submit');
		clearButton.classList.add('input-search__clear');
		searchInput.required = true;

		submitButton.addEventListener('click', (e) => {
			e.preventDefault();
			const currentForm = e.target.closest('form');

			if (currentForm) {
				currentForm.submit();
			}
		});

		clearButton.addEventListener('click', (e) => {
			e.preventDefault();
			searchInput.value = '';
		});

		if (
			!searchInput.hasAttribute('step') ||
			'any' === searchInput.getAttribute('step')
		) {
			searchInput.setAttribute('step', 1);
		}

		searchInput.parentNode.insertBefore(wrapper, searchInput);
		wrapper.appendChild(searchInput);
		wrapper.appendChild(submitButton);
		wrapper.appendChild(clearButton);
	});
};

const renderFloatForm = (form) => {
	const labels = form.querySelectorAll('label[for]');

	labels.forEach((label) => {
		const inputId = label.getAttribute('for');
		const input = form.querySelector(`#${inputId}`);

		if (!input || input.placeholder) {
			return;
		}

		const inputType = input.getAttribute('type');

		const validTypes = [
			'text',
			'password',
			'email',
			'search',
			'tel',
			'url',
			'number',
			'date',
			'time',
			'datetime-local',
			'week',
			'month',
		];

		if (
			('INPUT' !== input.tagName &&
				'TEXTAREA' !== input.tagName &&
				'SELECT' !== input.tagName) ||
			(inputType && !validTypes.includes(inputType))
		) {
			return;
		}

		const isSelect = 'SELECT' === input.tagName;

		const target = isSelect
			? input.closest('.form-select') || input
			: input;

		if (target.closest('.component-form__float-wrapper')) {
			return;
		}

		const wrapper = document.createElement('div');
		wrapper.className = 'component-form__float-wrapper';

		if ('TEXTAREA' === input.tagName) {
			wrapper.classList.add('component-form__float-wrapper--textarea');
			label.classList = 'component-form__float-textarea-label';
		} else if (isSelect) {
			label.classList = 'component-form__float-select-label';
		} else {
			label.classList = 'component-form__float-label';
		}

		target.parentNode.insertBefore(wrapper, target);

		if (!isSelect) {
			if (!input.placeholder) {
				input.setAttribute('placeholder', '');
			}

			input.classList.add('component-form__float-input');
		}

		wrapper.appendChild(target);
		wrapper.appendChild(label);
	});
};

const initializeFloatForms = () => {
	const forms = document.querySelectorAll('.component-form--float');

	if (0 === forms.length) {
		return;
	}

	forms.forEach((form) => {
		renderFloatForm(form);
		form.classList.add('component-form--float-initialized');
	});

	window.addEventListener('propel-form-submit', (e) => {
		const formWrapper = e.detail.formWrapper;

		if (!formWrapper || !formWrapper.closest('.component-form--float')) {
			return;
		}

		renderFloatForm(formWrapper);
	});

	window.addEventListener('propel-hubspot-form-render', (e) => {
		const formWrapper = e.detail.formWrapper;

		if (!formWrapper || !formWrapper.closest('.component-form--float')) {
			return;
		}

		renderFloatForm(formWrapper);
	});
};

addNumberInputButtons();
addFileInputButtons();
addSearchInputButtons();
initializeFloatForms();

window.addEventListener('propel-hubspot-form-render', (e) => {
	const formWrapper = e.detail.formWrapper;

	if (!formWrapper) {
		return;
	}

	addNumberInputButtons(formWrapper);
	addFileInputButtons(formWrapper);
	addSearchInputButtons(formWrapper);
});

};
propelInit();
window.propel = window.propel || {};
window.propel.blocks = window.propel.blocks || {};
window.propel.blocks['form'] = window.propel.blocks['form'] || {};
window.propel.blocks['form'].script = propelInit;
